import { Box } from '@apia/theme';
import { useResponsiveTableContext } from '../ResponsiveTableContext';
import { useContext } from 'react';
import { TableLoadingContext } from '../chanchullos/LoadingContext';

export const NoRegistersRenderer = () => {
  const { labels } = useResponsiveTableContext();
  const { current } = useContext(TableLoadingContext);

  return (
    <Box className="no__registers">{current ? labels.noRegisters : ''}</Box>
  );
};
